const ORACLE_ENVS = {
  MENU_KEY_pa_oracle: 'MENU_KEY_pa_oracle',

  GRIDCOLUMNS_pa_oracleSqlSummary_topSql: 'GRIDCOLUMNS_pa_oracleSqlSummary_topSql',
  FILTERSEARCH_pa_oracleSqlSummary_topSql: 'FILTERSEARCH_pa_oracleSqlSummary_topSql',

  GRIDCOLUMNS_pa_oracleTopNAnalysis_sql: 'GRIDCOLUMNS_pa_oracleTopNAnalysis_topSql',
  GRIDCOLUMNS_pa_oracleTopNAnalysis_schema: 'GRIDCOLUMNS_pa_oracleTopNAnalysis_schema',
  GRIDCOLUMNS_pa_oracleTopNAnalysis_module: 'GRIDCOLUMNS_pa_oracleTopNAnalysis_module',

  FILTERSEARCH_pa_oracleTopNAnalysis_sql: 'FILTERSEARCH_pa_oracleTopNAnalysis_sql',
  FILTERSEARCH_pa_oracleTopNAnalysis_schema: 'FILTERSEARCH_pa_oracleTopNAnalysis_schema',
  FILTERSEARCH_pa_oracleTopNAnalysis_module: 'FILTERSEARCH_pa_oracleTopNAnalysis_module',

  GRIDCOLUMNS_pa_oraclePlanAnalysis_planAnalysisList:
    'GRIDCOLUMNS_pa_oraclePlanAnalysis_planAnalysisList',
  GRIDCOLUMNS_pa_oraclePlanAnalysis_sqlList: 'GRIDCOLUMNS_pa_oraclePlanAnalysis_sqlList',
  GRIDCOLUMNS_pa_oraclePlanAnalysis_plan: 'GRIDCOLUMNS_pa_oraclePlanAnalysis_plan',

  GRIDCOLUMNS_pa_oracleSearchSql_sqlList: 'GRIDCOLUMNS_pa_oracleSearchSql_sqlList',
  GRIDCOLUMNS_pa_oracleSearchSql_history: 'GRIDCOLUMNS_pa_oracleSearchSql_history',
  GRIDCOLUMNS_pa_oracleSearchSql_plan: 'GRIDCOLUMNS_pa_oracleSearchSql_plan',

  GRIDCOLUMNS_pa_oracleWaitSummary_waitSqlList: 'GRIDCOLUMNS_pa_oracleWaitSummary_waitSqlList',

  GRIDCOLUMNS_pa_oracleSearchSession_searchSessionList:
    'GRIDCOLUMNS_pa_oracleSearchSession_searchSessionList',
  FILTERSEARCH_pa_oracleSearchSession_searchSessionList:
    'FILTERSEARCH_pa_oracleSearchSession_searchSessionList',

  TREND_METRIC_pa_oracleTrendAnalysis: 'TREND_METRIC_pa_oracleTrendAnalysis',
  GRIDCOLUMNS_pa_oracleTrendAnalysis_session: 'GRIDCOLUMNS_pa_oracleTrendAnalysis_session',
  GRIDCOLUMNS_pa_oracleTrendAnalysis_waitChains: 'GRIDCOLUMNS_pa_oracleTrendAnalysis_waitChains',
  GRIDCOLUMNS_pa_oracleTrendAnalysis_topSql: 'GRIDCOLUMNS_pa_oracleTrendAnalysis_topSql',
  GRIDCOLUMNS_pa_oracleTrendAnalysis_eventLeft: 'GRIDCOLUMNS_pa_oracleTrendAnalysis_eventLeft',
  GRIDCOLUMNS_pa_oracleTrendAnalysis_eventRight: 'GRIDCOLUMNS_pa_oracleTrendAnalysis_eventRight',
  GRIDCOLUMNS_pa_oracleTrendAnalysis_longSessionQuery:
    'GRIDCOLUMNS_pa_oracleTrendAnalysis_longSessionQuery',

  FILTERSEARCH_pa_oracleTrendAnalysis_session: 'FILTERSEARCH_pa_oracleTrendAnalysis_session',
  FILTERSEARCH_pa_oracleTrendAnalysis_waitChains: 'FILTERSEARCH_pa_oracleTrendAnalysis_waitChains',
  FILTERSEARCH_pa_oracleTrendAnalysis_topSql: 'FILTERSEARCH_pa_oracleTrendAnalysis_topSql',
  FILTERSEARCH_pa_oracleTrendAnalysis_eventLeft: 'FILTERSEARCH_pa_oracleTrendAnalysis_eventLeft',
  FILTERSEARCH_pa_oracleTrendAnalysis_eventRight: 'FILTERSEARCH_pa_oracleTrendAnalysis_eventRight',
  FILTERSEARCH_pa_oracleTrendAnalysis_longSessionQuery:
    'FILTERSEARCH_pa_oracleTrendAnalysis_longSessionQuery',
  GRIDCOLUMNS_pa_oracleTrendAnalysis_alert: 'GRIDCOLUMNS_pa_oracleTrendAnalysis_alert',
  FILTERSEARCH_pa_oracleTrendAnalysis_alert: 'FILTERSEARCH_pa_oracleTrendAnalysis_alert',

  GRIDCOLUMNS_pa_oracleParameterHistory_parameterList:
    'GRIDCOLUMNS_pa_oracleParameterHistory_parameterList',
  FILTERSEARCH_pa_oracleParameterHistory_parameterList:
    'FILTERSEARCH_pa_oracleParameterHistory_parameterList',

  GRIDCOLUMNS_pa_oracleAlertHistory_alertList: 'GRIDCOLUMNS_pa_oracleAlertHistory_alertList',

  GRIDCOLUMNS_pa_oracleTablespace_asmGroup: 'GRIDCOLUMNS_pa_oracleTablespace_asmGroup',
  GRIDCOLUMNS_pa_oracleTablespace_top100Tablespace:
    'GRIDCOLUMNS_pa_oracleTablespace_top100Tablespace',
  GRIDCOLUMNS_pa_oracleTablespace_top100Segment: 'GRIDCOLUMNS_pa_oracleTablespace_top100Segment',

  GRIDCOLUMNS_pa_oracleUndoTemp_undoSessionList: 'GRIDCOLUMNS_pa_oracleUndoTemp_undoSessionList',
  GRIDCOLUMNS_pa_oracleUndoTemp_tempSessionList: 'GRIDCOLUMNS_pa_oracleUndoTemp_tempSessionList',

  GRIDCOLUMNS_pa_oracleSqlDetail_historyTab: 'GRIDCOLUMNS_pa_oracleSqlDetail_historyTab',
  GRIDCOLUMNS_pa_oracleSqlDetail_planTab: 'GRIDCOLUMNS_pa_oracleSqlDetail_planTab',
};

const POSTGRESQL_ENVS = {
  MENU_KEY_pa_postgresql: 'MENU_KEY_pa_postgresql',

  GRIDCOLUMNS_pa_postgresSqlTopNAnalysis_topSql: 'GRIDCOLUMNS_pa_postgresSqlTopNAnalysis_topSql',
  GRIDCOLUMNS_pa_postgresSqlTopNAnalysis_topUser: 'GRIDCOLUMNS_pa_postgresSqlTopNAnalysis_topUser',
  GRIDCOLUMNS_pa_postgresqlTopNAnalysis_database: 'GRIDCOLUMNS_pa_postgresqlTopNAnalysis_database',

  FILTERSEARCH_pa_postgresqlTopNAnalysis_sql: 'FILTERSEARCH_pa_postgresqlTopNAnalysis_sql',
  FILTERSEARCH_pa_postgresqlTopNAnalysis_user: 'FILTERSEARCH_pa_postgresqlTopNAnalysis_user',
  FILTERSEARCH_pa_postgresqlTopNAnalysis_database:
    'FILTERSEARCH_pa_postgresqlTopNAnalysis_database',

  GRIDCOLUMNS_pa_postgresSqlSearchSql_searchSqlList:
    'GRIDCOLUMNS_pa_postgresSqlSearchSql_searchSqlList',
  GRIDCOLUMNS_pa_postgresSqlSearchSql_searchSqlHistory:
    'GRIDCOLUMNS_pa_postgresSqlSearchSql_searchSqlHistory',
  GRIDCOLUMNS_pa_postgresSqlSearchSql_plan: 'GRIDCOLUMNS_pa_postgresSqlSearchSql_plan',

  GRIDCOLUMNS_pa_postgresqlSearchSession_searchSessionList:
    'GRIDCOLUMNS_pa_postgresSqlSearchSession_searchSessionList',
  FILTERSEARCH_pa_postgresqlSearchSession_searchSessionList:
    'FILTERSEARCH_pa_postgresqlSearchSession_searchSessionList',

  TREND_METRIC_pa_postgresqlTrendAnalysis: 'TREND_METRIC_pa_postgresqlTrendAnalysis',
  GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_backends:
    'GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_backends',
  GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_lockTree:
    'GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_lockTree',
  GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_topSql: 'GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_topSql',
  GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_scanRatio:
    'GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_scanRatio',
  GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_topEvent:
    'GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_topEvent',
  GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_longActiveBackends:
    'GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_longActiveBackends',
  GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_applicationRatio:
    'GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_applicationRatio',
  GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_userRatio:
    'GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_userRatio',
  GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_alert: 'GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_alert',
  GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_Vacuum: 'GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_Vacuum',
  GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_topObject:
    'GRIDCOLUMNS_pa_postgresSqlTrendAnalysis_topObject',

  FILTERSEARCH_pa_postgresSqlTrendAnalysis_backends:
    'FILTERSEARCH_pa_postgresSqlTrendAnalysis_backends',
  FILTERSEARCH_pa_postgresSqlTrendAnalysis_lockTree:
    'FILTERSEARCH_pa_postgresSqlTrendAnalysis_lockTree',
  FILTERSEARCH_pa_postgresSqlTrendAnalysis_topSql:
    'FILTERSEARCH_pa_postgresSqlTrendAnalysis_topSql',
  FILTERSEARCH_pa_postgresSqlTrendAnalysis_scanRatio:
    'FILTERSEARCH_pa_postgresSqlTrendAnalysis_scanRatio',
  FILTERSEARCH_pa_postgresSqlTrendAnalysis_topEvent:
    'FILTERSEARCH_pa_postgresSqlTrendAnalysis_topEvent',
  FILTERSEARCH_pa_postgresSqlTrendAnalysis_longActiveBackends:
    'FILTERSEARCH_pa_postgresSqlTrendAnalysis_longActiveBackends',
  FILTERSEARCH_pa_postgresSqlTrendAnalysis_applicationRatio:
    'FILTERSEARCH_pa_postgresSqlTrendAnalysis_applicationRatio',
  FILTERSEARCH_pa_postgresSqlTrendAnalysis_userRatio:
    'FILTERSEARCH_pa_postgresSqlTrendAnalysis_userRatio',
  FILTERSEARCH_pa_postgresSqlTrendAnalysis_alert: 'FILTERSEARCH_pa_postgresSqlTrendAnalysis_alert',
  FILTERSEARCH_pa_postgresSqlTrendAnalysis_Vacuum:
    'FILTERSEARCH_pa_postgresSqlTrendAnalysis_Vacuum',
  FILTERSEARCH_pa_postgresSqlTrendAnalysis_topObject:
    'FILTERSEARCH_pa_postgresSqlTrendAnalysis_topObject',

  GRIDCOLUMNS_pa_postgresSqlParameterHistory_parameterList:
    'GRIDCOLUMNS_pa_postgresSqlParameterHistory_parameterList',
  FILTERSEARCH_pa_postgresSqlParameterHistory_parameterList:
    'FILTERSEARCH_pa_postgresSqlParameterHistory_parameterList',

  GRIDCOLUMNS_pa_postgresSqlObjectSize_databaseSizeInfo:
    'GRIDCOLUMNS_pa_postgresSqlObjectSize_databaseSizeInfo',
  GRIDCOLUMNS_pa_postgresSqlObjectSize_topObject: 'GRIDCOLUMNS_pa_postgresSqlObjectSize_topObject',
  GRIDCOLUMNS_pa_postgresSqlObjectSizeDetail_objectHistory:
    'GRIDCOLUMNS_pa_postgresSqlObjectSizeDetail_objectHistory',
  FILTERSEARCH_pa_postgresSqlObjectSizeDetail_objectHistory:
    'FILTERSEARCH_pa_postgresSqlObjectSizeDetail_objectHistory',
  GRIDCOLUMNS_pa_postgresSqlObjectSizeDetail_vacuumStatistics:
    'GRIDCOLUMNS_pa_postgresSqlObjectSizeDetail_vacuumStatistics',
  FILTERSEARCH_pa_postgresSqlObjectSizeDetail_vacuumStatistics:
    'FILTERSEARCH_pa_postgresSqlObjectSizeDetail_vacuumStatistics',
  GRIDCOLUMNS_pa_postgresSqlObjectSizeDetail_vacuumDbParameter:
    'GRIDCOLUMNS_pa_postgresSqlObjectSizeDetail_vacuumDbParameter',
  FILTERSEARCH_pa_postgresSqlObjectSizeDetail_vacuumDbParameter:
    'FILTERSEARCH_pa_postgresSqlObjectSizeDetail_vacuumDbParameter',
  GRIDCOLUMNS_pa_postgresSqlObjectSizeDetail_vacuumBackendsList:
    'FILTERSEARCH_pa_postgresSqlObjectSizeDetail_vacuumBackendsList',
  FILTERSEARCH_pa_postgresSqlObjectSizeDetail_vacuumBackendsList:
    'FILTERSEARCH_pa_postgresSqlObjectSizeDetail_vacuumBackendsList',

  GRIDCOLUMNS_pa_postgresSqlSqlDetailSlide_planView:
    'GRIDCOLUMNS_pa_postgresSqlSqlDetailSlide_planView',
  GRIDCOLUMNS_pa_postgresSqlSessionDetailWindow_planView:
    'GRIDCOLUMNS_pa_postgresSqlSessionDetailWindow_planView',
};

const MYSQL_ENVS = {
  MENU_KEY_pa_mysql: 'MENU_KEY_pa_mysql',

  GRIDCOLUMNS_pa_mysqlTopNAnalysis_sql: 'GRIDCOLUMNS_pa_mySqlTopNAnalysis_topSql',
  GRIDCOLUMNS_pa_mysqlTopNAnalysis_schema: 'GRIDCOLUMNS_pa_mySqlTopNAnalysis_topSchema',

  FILTERSEARCH_pa_mysqlTopNAnalysis_sql: 'FILTERSEARCH_pa_mySqlTopNAnalysis_topSql',
  FILTERSEARCH_pa_mysqlTopNAnalysis_schema: 'FILTERSEARCH_pa_mySqlTopNAnalysis_topSchema',

  GRIDCOLUMNS_pa_mysqlSearchSql_searchSqlList: 'GRIDCOLUMNS_pa_mySqlSearchSql_searchSqlList',
  GRIDCOLUMNS_pa_mysqlSearchSql_searchSqlHistory: 'GRIDCOLUMNS_pa_mysqlSearchSql_searchSqlHistory',
  GRIDCOLUMNS_pa_mysqlSearchSql_searchSqlPlan: 'GRIDCOLUMNS_pa_mysqlSearchSql_searchSqlPlan',

  GRIDCOLUMNS_pa_mysqlSearchSession_searchSessionList:
    'GRIDCOLUMNS_pa_mySqlSearchSession_searchSessionList',
  FILTERSEARCH_pa_mysqlSearchSession_searchSessionList:
    'FILTERSEARCH_pa_mySqlSearchSession_searchSessionList',

  TREND_METRIC_pa_mysqlTrendAnalysis: 'TREND_METRIC_pa_mysqlTrendAnalysis',
  GRIDCOLUMNS_pa_mysqlTrendAnalysis_threads: 'GRIDCOLUMNS_pa_mySqlTrendAnalysis_threads',
  GRIDCOLUMNS_pa_mysqlTrendAnalysis_processList: 'GRIDCOLUMNS_pa_mySqlTrendAnalysis_processList',
  GRIDCOLUMNS_pa_mysqlTrendAnalysis_lockTree: 'GRIDCOLUMNS_pa_mySqlTrendAnalysis_lockTree',
  GRIDCOLUMNS_pa_mysqlTrendAnalysis_metaLockTree: 'GRIDCOLUMNS_pa_mySqlTrendAnalysis_metaLockTree',
  GRIDCOLUMNS_pa_mysqlTrendAnalysis_topSql: 'GRIDCOLUMNS_pa_mySqlTrendAnalysis_topSql',
  GRIDCOLUMNS_pa_mysqlTrendAnalysis_topEvent: 'GRIDCOLUMNS_pa_mySqlTrendAnalysis_topEvent',
  GRIDCOLUMNS_pa_mysqlTrendAnalysis_longActiveThread:
    'GRIDCOLUMNS_pa_mySqlTrendAnalysis_longActiveThread',
  GRIDCOLUMNS_pa_mysqlTrendAnalysis_userConnectionInfo:
    'GRIDCOLUMNS_pa_mySqlTrendAnalysis_userConnectionInfo',
  GRIDCOLUMNS_pa_mysqlTrendAnalysis_alert: 'GRIDCOLUMNS_pa_mySqlTrendAnalysis_alert',
  GRIDCOLUMNS_pa_mysqlTrendAnalysis_slowQuery: 'GRIDCOLUMNS_pa_mySqlTrendAnalysis_slowQuery',

  FILTERSEARCH_pa_mysqlTrendAnalysis_threads: 'FILTERSEARCH_pa_mySqlTrendAnalysis_threads',
  FILTERSEARCH_pa_mysqlTrendAnalysis_processList: 'FILTERSEARCH_pa_mySqlTrendAnalysis_processList',
  FILTERSEARCH_pa_mysqlTrendAnalysis_lockTree: 'FILTERSEARCH_pa_mySqlTrendAnalysis_lockTree',
  FILTERSEARCH_pa_mysqlTrendAnalysis_metaLockTree:
    'FILTERSEARCH_pa_mySqlTrendAnalysis_metaLockTree',
  FILTERSEARCH_pa_mysqlTrendAnalysis_topSql: 'FILTERSEARCH_pa_mySqlTrendAnalysis_topSql',
  FILTERSEARCH_pa_mysqlTrendAnalysis_topEvent: 'FILTERSEARCH_pa_mySqlTrendAnalysis_topEvent',
  FILTERSEARCH_pa_mysqlTrendAnalysis_longActiveThread:
    'FILTERSEARCH_pa_mySqlTrendAnalysis_longActiveThread',
  FILTERSEARCH_pa_mysqlTrendAnalysis_userConnectionInfo:
    'FILTERSEARCH_pa_mySqlTrendAnalysis_userConnectionInfo',
  FILTERSEARCH_pa_mysqlTrendAnalysis_alert: 'FILTERSEARCH_pa_mySqlTrendAnalysis_alert',
  FILTERSEARCH_pa_mysqlTrendAnalysis_slowQuery: 'FILTERSEARCH_pa_mySqlTrendAnalysis_slowQuery',

  GRIDCOLUMNS_pa_mysqlParameterHistory_parameterList:
    'GRIDCOLUMNS_pa_mySqlParameterHistory_parameterList',
  FILTERSEARCH_pa_mysqlParameterHistory_parameterList:
    'FILTERSEARCH_pa_mySqlParameterHistory_parameterList',

  GRIDCOLUMNS_pa_mysqlObjectSize_databaseSizeInfo:
    'GRIDCOLUMNS_pa_mySqlObjectSize_databaseSizeInfo',
  GRIDCOLUMNS_pa_mysqlObjectSize_topObject: 'GRIDCOLUMNS_pa_mySqlObjectSize_topObject',
  GRIDCOLUMNS_pa_mysqlObjectSizeDetail_objectHistory:
    'GRIDCOLUMNS_pa_mySqlObjectSizeDetail_objectHistory',
  FILTERSEARCH_pa_mysqlObjectSizeDetail_objectHistory:
    'FILTERSEARCH_pa_mySqlObjectSizeDetail_objectHistory',

  GRIDCOLUMNS_pa_mysqlSqlDetailSlide_planView: 'GRIDCOLUMNS_pa_mySqlSqlDetailSlide_planView',
};

const SQLSERVER_ENVS = {
  MENU_KEY_pa_sqlserver: 'MENU_KEY_pa_sqlserver',

  GRIDCOLUMNS_pa_sqlserverTopNAnalysis_sql: 'GRIDCOLUMNS_pa_sqlServerTopNAnalysis_topSql',
  GRIDCOLUMNS_pa_sqlserverTopNAnalysis_procedure:
    'GRIDCOLUMNS_pa_sqlServerTopNAnalysis_topProcedure',

  FILTERSEARCH_pa_sqlserverTopNAnalysis_sql: 'FILTERSEARCH_pa_sqlserverTopNAnalysis_sql',
  FILTERSEARCH_pa_sqlserverTopNAnalysis_procedure:
    'FILTERSEARCH_pa_sqlserverTopNAnalysis_procedure',

  GRIDCOLUMNS_pa_sqlServerPlanAnalysis_planAnalysisList:
    'GRIDCOLUMNS_pa_sqlServerPlanAnalysis_planAnalysisList',
  GRIDCOLUMNS_pa_sqlServerPlanAnalysis_sqlList: 'GRIDCOLUMNS_pa_sqlServerPlanAnalysis_sqlList',
  GRIDCOLUMNS_pa_sqlServerPlanAnalysis_plan: 'GRIDCOLUMNS_pa_sqlServerPlanAnalysis_plan',

  GRIDCOLUMNS_pa_sqlServerSearchSql_searchSqlList:
    'GRIDCOLUMNS_pa_sqlServerSearchSql_searchSqlList',
  GRIDCOLUMNS_pa_sqlServerSearchSql_searchSqlHistory:
    'GRIDCOLUMNS_pa_sqlServerSearchSql_searchSqlHistory',
  GRIDCOLUMNS_pa_sqlServerSearchSql_plan: 'GRIDCOLUMNS_pa_sqlServerSearchSql_plan',

  GRIDCOLUMNS_pa_sqlServerSearchSession_searchSessionList:
    'GRIDCOLUMNS_pa_sqlServerSearchSession_searchSessionList',
  FILTERSEARCH_pa_sqlServerSearchSession_searchSessionList:
    'FILTERSEARCH_pa_sqlServerSearchSession_searchSessionList',

  TREND_METRIC_pa_sqlServerTrendAnalysis: 'TREND_METRIC_pa_sqlServerTrendAnalysis',
  GRIDCOLUMNS_pa_sqlServerTrendAnalysis_session: 'GRIDCOLUMNS_pa_sqlServerTrendAnalysis_session',
  GRIDCOLUMNS_pa_sqlServerTrendAnalysis_blockedTop:
    'GRIDCOLUMNS_pa_sqlServerTrendAnalysis_blockedTop',
  GRIDCOLUMNS_pa_sqlServerTrendAnalysis_blockedBottom:
    'GRIDCOLUMNS_pa_sqlServerTrendAnalysis_blockedBottom',
  GRIDCOLUMNS_pa_sqlServerTrendAnalysis_sqlStat: 'GRIDCOLUMNS_pa_sqlServerTrendAnalysis_sqlStat',
  GRIDCOLUMNS_pa_sqlServerTrendAnalysis_wait: 'GRIDCOLUMNS_pa_sqlServerTrendAnalysis_wait',
  GRIDCOLUMNS_pa_sqlServerTrendAnalysis_topSql: 'GRIDCOLUMNS_pa_sqlServerTrendAnalysis_topSql',

  FILTERSEARCH_pa_sqlServerTrendAnalysis_session: 'FILTERSEARCH_pa_sqlServerTrendAnalysis_session',
  FILTERSEARCH_pa_sqlServerTrendAnalysis_blockedTop:
    'FILTERSEARCH_pa_sqlServerTrendAnalysis_blockedTop',
  FILTERSEARCH_pa_sqlServerTrendAnalysis_blockedBottom:
    'FILTERSEARCH_pa_sqlServerTrendAnalysis_blockedBottom',
  FILTERSEARCH_pa_sqlServerTrendAnalysis_sqlStat: 'FILTERSEARCH_pa_sqlServerTrendAnalysis_sqlStat',
  FILTERSEARCH_pa_sqlServerTrendAnalysis_wait: 'FILTERSEARCH_pa_sqlServerTrendAnalysis_wait',
  FILTERSEARCH_pa_sqlServerTrendAnalysis_topSql: 'FILTERSEARCH_pa_sqlServerTrendAnalysis_topSql',
  GRIDCOLUMNS_pa_sqlServerTrendAnalysis_alert: 'GRIDCOLUMNS_pa_sqlServerTrendAnalysis_alert',
  FILTERSEARCH_pa_sqlServerTrendAnalysis_alert: 'FILTERSEARCH_pa_sqlServerTrendAnalysis_alert',

  GRIDCOLUMNS_pa_sqlServerParameterHistory_parameterList:
    'GRIDCOLUMNS_pa_sqlServerParameterHistory_parameterList',
  FILTERSEARCH_pa_sqlServerParameterHistory_parameterList:
    'FILTERSEARCH_pa_sqlServerParameterHistory_parameterList',

  GRIDCOLUMNS_pa_sqlServerAlertHistory_alertList: 'GRIDCOLUMNS_pa_sqlServerAlertHistory_alertList',

  GRIDCOLUMNS_pa_sqlServerDbInfo_dbSizeInfo: 'GRIDCOLUMNS_pa_sqlServerDbInfo_dbSizeInfo',
  GRIDCOLUMNS_pa_sqlServerDbInfo_dbInfo: 'GRIDCOLUMNS_pa_sqlServerDbInfo_dbInfo',
  GRIDCOLUMNS_pa_sqlServerDbInfo_dbFileInfo: 'GRIDCOLUMNS_pa_sqlServerDbInfo_dbFileInfo',
  GRIDCOLUMNS_pa_sqlServerDbInfo_topTable: 'GRIDCOLUMNS_pa_sqlServerDbInfo_topTable',

  GRIDCOLUMNS_pa_sqlServerSqlDetailSlide_plan: 'GRIDCOLUMNS_pa_sqlServerSqlDetailSlide_plan',
  GRIDCOLUMNS_pa_sqlServerSqlDetailSlide_parameterList:
    'GRIDCOLUMNS_pa_sqlServerSqlDetailSlide_parameterList',

  GRIDCOLUMNS_pa_sqlServerSessionDetailSlide_plan:
    'GRIDCOLUMNS_pa_sqlServerSessionDetailSlide_plan',
  GRIDCOLUMNS_pa_sqlServerSessionDetailSlide_parameterList:
    'GRIDCOLUMNS_pa_sqlServerSessionDetailSlide_parameterList',
  GRIDCOLUMNS_pa_sqlServerSessionDetailSlide_activeSessionHistory:
    'GRIDCOLUMNS_pa_sqlServerSessionDetailSlide_activeSessionHistory',
};

const ALTIBASE_ENVS = {
  MENU_KEY_pa_altibase: 'MENU_KEY_pa_altibase',

  GRIDCOLUMNS_pa_altibaseTopNAnalysis_sql: 'GRIDCOLUMNS_pa_altibaseTopNAnalysis_sql',
  GRIDCOLUMNS_pa_altibaseTopNAnalysis_schema: 'GRIDCOLUMNS_pa_altibaseTopNAnalysis_schema',
  GRIDCOLUMNS_pa_altibaseTopNAnalysis_module: 'GRIDCOLUMNS_pa_altibaseTopNAnalysis_module',

  FILTERSEARCH_pa_altibaseTopNAnalysis_sql: 'FILTERSEARCH_pa_altibaseTopNAnalysis_sql',
  FILTERSEARCH_pa_altibaseTopNAnalysis_schema: 'FILTERSEARCH_pa_altibaseTopNAnalysis_schema',
  FILTERSEARCH_pa_altibaseTopNAnalysis_module: 'FILTERSEARCH_pa_altibaseTopNAnalysis_module',

  TREND_METRIC_pa_altibaseTrendAnalysis: 'TREND_METRIC_pa_altibaseTrendAnalysis',
  GRIDCOLUMNS_pa_altibaseTrendAnalysis_session: 'GRIDCOLUMNS_pa_altibaseTrendAnalysis_session',
  GRIDCOLUMNS_pa_altibaseTrendAnalysis_lockTree: 'GRIDCOLUMNS_pa_altibaseTrendAnalysis_lockTree',
  GRIDCOLUMNS_pa_altibaseTrendAnalysis_topSql: 'GRIDCOLUMNS_pa_altibaseTrendAnalysis_topSql',
  GRIDCOLUMNS_pa_altibaseTrendAnalysis_topWait: 'GRIDCOLUMNS_pa_altibaseTrendAnalysis_topWait',
  GRIDCOLUMNS_pa_altibaseTrendAnalysis_topEvent: 'GRIDCOLUMNS_pa_altibaseTrendAnalysis_topEvent',
  GRIDCOLUMNS_pa_altibaseTrendAnalysis_longActiveSession:
    'GRIDCOLUMNS_pa_altibaseTrendAnalysis_longActiveSession',
  GRIDCOLUMNS_pa_altibaseTrendAnalysis_topProcesses:
    'GRIDCOLUMNS_pa_altibaseTrendAnalysis_topProcesses',

  FILTERSEARCH_pa_altibaseTrendAnalysis_session: 'FILTERSEARCH_pa_altibaseTrendAnalysis_session',
  FILTERSEARCH_pa_altibaseTrendAnalysis_lockTree: 'FILTERSEARCH_pa_altibaseTrendAnalysis_lockTree',
  FILTERSEARCH_pa_altibaseTrendAnalysis_topSql: 'FILTERSEARCH_pa_altibaseTrendAnalysis_topSql',
  FILTERSEARCH_pa_altibaseTrendAnalysis_topWait: 'FILTERSEARCH_pa_altibaseTrendAnalysis_topWait',
  FILTERSEARCH_pa_altibaseTrendAnalysis_topEvent: 'FILTERSEARCH_pa_altibaseTrendAnalysis_topEvent',
  FILTERSEARCH_pa_altibaseTrendAnalysis_longActiveSession:
    'FILTERSEARCH_pa_altibaseTrendAnalysis_longActiveSession',
  FILTERSEARCH_pa_altibaseTrendAnalysis_topProcesses:
    'FILTERSEARCH_pa_altibaseTrendAnalysis_topProcesses',
  GRIDCOLUMNS_pa_altibaseTrendAnalysis_alert: 'GRIDCOLUMNS_pa_altibaseTrendAnalysis_alert',
  FILTERSEARCH_pa_altibaseTrendAnalysis_alert: 'FILTERSEARCH_pa_altibaseTrendAnalysis_alert',

  GRIDCOLUMNS_pa_altibaseReplication_topReplicationObjects:
    'GRIDCOLUMNS_pa_altibaseReplication_topReplicationObjects',
  GRIDCOLUMNS_pa_altibaseReplication_status: 'GRIDCOLUMNS_pa_altibaseReplication_status',
  GRIDCOLUMNS_pa_altibaseReplication_session: 'GRIDCOLUMNS_pa_altibaseReplication_session',

  FILTERSEARCH_pa_altibaseReplication_topReplicationObjects:
    'FILTERSEARCH_pa_altibaseReplication_topReplicationObjects',
  FILTERSEARCH_pa_altibaseReplication_status: 'FILTERSEARCH_pa_altibaseReplication_status',
  FILTERSEARCH_pa_altibaseReplication_session: 'FILTERSEARCH_pa_altibaseReplication_session',
};

const TIBERO_ENVS = {
  MENU_KEY_pa_tibero: 'MENU_KEY_pa_tibero',

  GRIDCOLUMNS_pa_tiberoTopNAnalysis_sql: 'GRIDCOLUMNS_pa_tiberoTopNAnalysis_sql',
  GRIDCOLUMNS_pa_tiberoTopNAnalysis_schema: 'GRIDCOLUMNS_pa_tiberoTopNAnalysis_schema',
  GRIDCOLUMNS_pa_tiberoTopNAnalysis_module: 'GRIDCOLUMNS_pa_tiberoTopNAnalysis_module',

  FILTERSEARCH_pa_tiberoTopNAnalysis_sql: 'FILTERSEARCH_pa_tiberoTopNAnalysis_sql',
  FILTERSEARCH_pa_tiberoTopNAnalysis_schema: 'FILTERSEARCH_pa_tiberoTopNAnalysis_schema',
  FILTERSEARCH_pa_tiberoTopNAnalysis_module: 'FILTERSEARCH_pa_tiberoTopNAnalysis_module',

  GRIDCOLUMNS_pa_tiberoSearchSession_searchSessionList:
    'GRIDCOLUMNS_pa_tiberoSearchSession_searchSessionList',
  FILTERSEARCH_pa_tiberoSearchSession_searchSessionList:
    'FILTERSEARCH_pa_tiberoSearchSession_searchSessionList',

  TREND_METRIC_pa_tiberoTrendAnalysis: 'TREND_METRIC_pa_tiberoTrendAnalysis',
  GRIDCOLUMNS_pa_tiberoTrendAnalysis_session: 'GRIDCOLUMNS_pa_tiberoTrendAnalysis_session',
  GRIDCOLUMNS_pa_tiberoTrendAnalysis_lock: 'GRIDCOLUMNS_pa_tiberoTrendAnalysis_lock',
  GRIDCOLUMNS_pa_tiberoTrendAnalysis_topSql: 'GRIDCOLUMNS_pa_tiberoTrendAnalysis_topSql',
  GRIDCOLUMNS_pa_tiberoTrendAnalysis_topWait: 'GRIDCOLUMNS_pa_tiberoTrendAnalysis_topWait',
  GRIDCOLUMNS_pa_tiberoTrendAnalysis_topEvent: 'GRIDCOLUMNS_pa_tiberoTrendAnalysis_topEvent',
  GRIDCOLUMNS_pa_tiberoTrendAnalysis_longSessionQuery:
    'GRIDCOLUMNS_pa_tiberoTrendAnalysis_longSessionQuery',

  FILTERSEARCH_pa_tiberoTrendAnalysis_session: 'FILTERSEARCH_pa_tiberoTrendAnalysis_session',
  FILTERSEARCH_pa_tiberoTrendAnalysis_lock: 'FILTERSEARCH_pa_tiberoTrendAnalysis_lock',
  FILTERSEARCH_pa_tiberoTrendAnalysis_topSql: 'FILTERSEARCH_pa_tiberoTrendAnalysis_topSql',
  FILTERSEARCH_pa_tiberoTrendAnalysis_topWait: 'FILTERSEARCH_pa_tiberoTrendAnalysis_topWait',
  FILTERSEARCH_pa_tiberoTrendAnalysis_topEvent: 'FILTERSEARCH_pa_tiberoTrendAnalysis_topEvent',
  FILTERSEARCH_pa_tiberoTrendAnalysis_longSessionQuery:
    'FILTERSEARCH_pa_tiberoTrendAnalysis_longSessionQuery',
  GRIDCOLUMNS_pa_tiberoTrendAnalysis_alert: 'GRIDCOLUMNS_pa_tiberoTrendAnalysis_alert',
  FILTERSEARCH_pa_tiberoTrendAnalysis_alert: 'FILTERSEARCH_pa_tiberoTrendAnalysis_alert',

  GRIDCOLUMNS_pa_tiberoParameterHistory_parameterList:
    'GRIDCOLUMNS_pa_tiberoParameterHistory_parameterList',
  FILTERSEARCH_pa_tiberoParameterHistory_parameterList:
    'FILTERSEARCH_pa_tiberoParameterHistory_parameterList',

  GRIDCOLUMNS_pa_tiberoTablespace_tasGroup: 'GRIDCOLUMNS_pa_tiberoTablespace_tasGroup',
  GRIDCOLUMNS_pa_tiberoTablespace_top100Tablespace:
    'GRIDCOLUMNS_pa_tiberoTablespace_top100Tablespace',
  GRIDCOLUMNS_pa_tiberoTablespace_top100Segment: 'GRIDCOLUMNS_pa_tiberoTablespace_top100Segment',

  GRIDCOLUMNS_pa_tiberoSearchSql_sqlList: 'GRIDCOLUMNS_pa_tiberoSearchSql_sqlList',
  GRIDCOLUMNS_pa_tiberoSearchSql_sqlHistory: 'GRIDCOLUMNS_pa_tiberoSearchSql_sqlHistory',
  GRIDCOLUMNS_pa_tiberoSearchSql_sqlPlan: 'GRIDCOLUMNS_pa_tiberoSearchSql_sqlPlan',

  FILTERSEARCH_pa_tiberoSearchSql_sqlList: 'FILTERSEARCH_pa_tiberoSearchSql_sqlList',
  FILTERSEARCH_pa_tiberoSearchSql_sqlHistory: 'FILTERSEARCH_pa_tiberoSearchSql_sqlHistory',
};

const CLICKHOUSE_ENVS = {
  MENU_KEY_pa_clickhouse: 'MENU_KEY_pa_clickhouse',

  GRIDCOLUMNS_pa_clickhouseTopNAnalysis_sql: 'GRIDCOLUMNS_pa_clickhouseTopNAnalysis_sql',
  GRIDCOLUMNS_pa_clickhouseTopNAnalysis_user: 'GRIDCOLUMNS_pa_clickhouseTopNAnalysis_user',
  GRIDCOLUMNS_pa_clickhouseTopNAnalysis_database: 'GRIDCOLUMNS_pa_clickhouseTopNAnalysis_database',

  FILTERSEARCH_pa_clickhouseTopNAnalysis_sql: 'FILTERSEARCH_pa_clickhouseTopNAnalysis_sql',
  FILTERSEARCH_pa_clickhouseTopNAnalysis_user: 'FILTERSEARCH_pa_clickhouseTopNAnalysis_user',
  FILTERSEARCH_pa_clickhouseTopNAnalysis_database:
    'FILTERSEARCH_pa_clickhouseTopNAnalysis_database',

  TREND_METRIC_pa_clickhouseTrendAnalysis: 'TREND_METRIC_pa_clickhouseTrendAnalysis',
  GRIDCOLUMNS_pa_clickhouseTrendAnalysis_process: 'GRIDCOLUMNS_pa_clickhouseTrendAnalysis_process',
  GRIDCOLUMNS_pa_clickhouseTrendAnalysis_topSql: 'GRIDCOLUMNS_pa_clickhouseTrendAnalysis_topSql',
  GRIDCOLUMNS_pa_clickhouseTrendAnalysis_longRunningQuery:
    'GRIDCOLUMNS_pa_clickhouseTrendAnalysis_longRunningQuery',
  GRIDCOLUMNS_pa_clickhouseTrendAnalysis_partLog: 'GRIDCOLUMNS_pa_clickhouseTrendAnalysis_partLog',
  GRIDCOLUMNS_pa_clickhouseTrendAnalysis_merge: 'GRIDCOLUMNS_pa_clickhouseTrendAnalysis_merge',
  GRIDCOLUMNS_pa_clickhouseTrendAnalysis_mutation:
    'GRIDCOLUMNS_pa_clickhouseTrendAnalysis_mutation',
  GRIDCOLUMNS_pa_clickhouseTrendAnalysis_alert: 'GRIDCOLUMNS_pa_clickhouseTrendAnalysis_alert',

  FILTERSEARCH_pa_clickhouseTrendAnalysis_process:
    'FILTERSEARCH_pa_clickhouseTrendAnalysis_process',
  FILTERSEARCH_pa_clickhouseTrendAnalysis_topSql: 'FILTERSEARCH_pa_clickhouseTrendAnalysis_topSql',
  FILTERSEARCH_pa_clickhouseTrendAnalysis_longRunningQuery:
    'FILTERSEARCH_pa_clickhouseTrendAnalysis_longRunningQuery',
  FILTERSEARCH_pa_clickhouseTrendAnalysis_partLog:
    'FILTERSEARCH_pa_clickhouseTrendAnalysis_partLog',
  FILTERSEARCH_pa_clickhouseTrendAnalysis_merge: 'FILTERSEARCH_pa_clickhouseTrendAnalysis_merge',
  FILTERSEARCH_pa_clickhouseTrendAnalysis_mutation:
    'FILTERSEARCH_pa_clickhouseTrendAnalysis_mutation',
  FILTERSEARCH_pa_clickhouseTrendAnalysis_alert: 'FILTERSEARCH_pa_clickhouseTrendAnalysis_alert',

  GRIDCOLUMNS_pa_clickhouseSearchSql_sqlList: 'GRIDCOLUMNS_pa_clickhouseSearchSql_sqlList',
  GRIDCOLUMNS_pa_clickhouseSearchSql_sqlHistory: 'GRIDCOLUMNS_pa_clickhouseSearchSql_sqlHistory',
  GRIDCOLUMNS_pa_clickhouseSearchSql_sqlPlan: 'GRIDCOLUMNS_pa_clickhouseSearchSql_sqlPlan',

  FILTERSEARCH_pa_clickhouseSearchSql_sqlList: 'FILTERSEARCH_pa_clickhouseSearchSql_sqlList',
  FILTERSEARCH_pa_clickhouseSearchSql_sqlHistory: 'FILTERSEARCH_pa_clickhouseSearchSql_sqlHistory',
};

const REDSHIFT_ENVS = {
  MENU_KEY_pa_redshift: 'MENU_KEY_pa_redshift',

  GRIDCOLUMNS_pa_redshiftTopNAnalysis_sql: 'GRIDCOLUMNS_pa_redshiftTopNAnalysis_sql',
  GRIDCOLUMNS_pa_redshiftTopNAnalysis_user: 'GRIDCOLUMNS_pa_redshiftTopNAnalysis_user',
  GRIDCOLUMNS_pa_redshiftTopNAnalysis_database: 'GRIDCOLUMNS_pa_redshiftTopNAnalysis_database',

  FILTERSEARCH_pa_redshiftTopNAnalysis_sql: 'FILTERSEARCH_pa_redshiftTopNAnalysis_sql',
  FILTERSEARCH_pa_redshiftTopNAnalysis_user: 'FILTERSEARCH_pa_redshiftTopNAnalysis_user',
  FILTERSEARCH_pa_redshiftTopNAnalysis_database: 'FILTERSEARCH_pa_redshiftTopNAnalysis_database',

  TREND_METRIC_pa_redshiftTrendAnalysis: 'TREND_METRIC_pa_redshiftTrendAnalysis',
  GRIDCOLUMNS_pa_redshiftTrendAnalysis_session: 'GRIDCOLUMNS_pa_redshiftTrendAnalysis_session',
  GRIDCOLUMNS_pa_redshiftTrendAnalysis_lock: 'GRIDCOLUMNS_pa_redshiftTrendAnalysis_lock',
  GRIDCOLUMNS_pa_redshiftTrendAnalysis_slowQuery: 'GRIDCOLUMNS_pa_redshiftTrendAnalysis_slowQuery',
  GRIDCOLUMNS_pa_redshiftTrendAnalysis_userLog: 'GRIDCOLUMNS_pa_redshiftTrendAnalysis_userLog',
  GRIDCOLUMNS_pa_redshiftTrendAnalysis_alert: 'GRIDCOLUMNS_pa_redshiftTrendAnalysis_alert',

  FILTERSEARCH_pa_redshiftTrendAnalysis_session: 'FILTERSEARCH_pa_redshiftTrendAnalysis_session',
  FILTERSEARCH_pa_redshiftTrendAnalysis_lock: 'FILTERSEARCH_pa_redshiftTrendAnalysis_lock',
  FILTERSEARCH_pa_redshiftTrendAnalysis_slowQuery:
    'FILTERSEARCH_pa_redshiftTrendAnalysis_slowQuery',
  FILTERSEARCH_pa_redshiftTrendAnalysis_userLog: 'FILTERSEARCH_pa_redshiftTrendAnalysis_userLog',
  FILTERSEARCH_pa_redshiftTrendAnalysis_alert: 'FILTERSEARCH_pa_redshiftTrendAnalysis_alert',
};

const SINGLESTORE_ENVS = {
  MENU_KEY_pa_singlestore: 'MENU_KEY_pa_singlestore',

  GRIDCOLUMNS_pa_singlestoreTopNAnalysis_sql: 'GRIDCOLUMNS_pa_singlestoreTopNAnalysis_sql',
  GRIDCOLUMNS_pa_singlestoreTopNAnalysis_node: 'GRIDCOLUMNS_pa_singlestoreTopNAnalysis_node',
  GRIDCOLUMNS_pa_singlestoreTopNAnalysis_db: 'GRIDCOLUMNS_pa_singlestoreTopNAnalysis_db',

  FILTERSEARCH_pa_singlestoreTopNAnalysis_sql: 'FILTERSEARCH_pa_singlestoreTopNAnalysis_sql',
  FILTERSEARCH_pa_singlestoreTopNAnalysis_node: 'FILTERSEARCH_pa_singlestoreTopNAnalysis_node',
  FILTERSEARCH_pa_singlestoreTopNAnalysis_db: 'FILTERSEARCH_pa_singlestoreTopNAnalysis_db',

  TREND_METRIC_pa_singlestoreTrendAnalysis: 'TREND_METRIC_pa_singlestoreTrendAnalysis',
  GRIDCOLUMNS_pa_singlestoreTrendAnalysis_activeQuery:
    'GRIDCOLUMNS_pa_singlestoreTrendAnalysis_activeQuery',
  GRIDCOLUMNS_pa_singlestoreTrendAnalysis_topSql: 'GRIDCOLUMNS_pa_singlestoreTrendAnalysis_topSql',
  GRIDCOLUMNS_pa_singlestoreTrendAnalysis_eventHistory:
    'GRIDCOLUMNS_pa_singlestoreTrendAnalysis_eventHistory',

  FILTERSEARCH_pa_singlestoreTrendAnalysis_activeQuery:
    'FILTERSEARCH_pa_singlestoreTrendAnalysis_activeQuery',
  FILTERSEARCH_pa_singlestoreTrendAnalysis_topSql:
    'FILTERSEARCH_pa_singlestoreTrendAnalysis_topSql',
  FILTERSEARCH_pa_singlestoreTrendAnalysis_eventHistory:
    'FILTERSEARCH_pa_singlestoreTrendAnalysis_eventHistory',
  GRIDCOLUMNS_pa_singlestoreTrendAnalysis_alert: 'GRIDCOLUMNS_pa_singlestoreTrendAnalysis_alert',
  FILTERSEARCH_pa_singlestoreTrendAnalysis_alert: 'FILTERSEARCH_pa_singlestoreTrendAnalysis_alert',
};

export const PA = {
  APPLICATION: {
    PA_TRANSACTION_TREND_DETAIL_DASHBOARD_SETTING_LIST:
      'PA_TRANSACTION_TREND_DETAIL_DASHBOARD_SETTING_LIST',
    PA_WEB_TRANSACTION_TREND_DETAIL_DASHBOARD_SETTING_LIST:
      'PA_WEB_TRANSACTION_TREND_DETAIL_DASHBOARD_SETTING_LIST',

    GRIDCOLUMNS_pa_trendAnalysis_activeSession: 'GRIDCOLUMNS_pa_trendAnalysis_activeSession',
    GRIDCOLUMNS_pa_trendAnalysis_activeSessionSum: 'GRIDCOLUMNS_pa_trendAnalysis_activeSessionSum',
    GRIDCOLUMNS_pa_trendAnalysis_activeSessionProcess:
      'GRIDCOLUMNS_pa_trendAnalysis_activeSessionProcess',

    GRIDCOLUMNS_pa_transactionTrend_transactionSummary:
      'GRIDCOLUMNS_pa_transactionTrend_transactionSummary',
    GRIDCOLUMNS_pa_transactionTrend_transactionList:
      'GRIDCOLUMNS_pa_transactionTrend_transactionList',

    GRIDCOLUMNS_pa_exceptionSummary_exceptionList: 'GRIDCOLUMNS_pa_exceptionSummary_exceptionList',
    GRIDCOLUMNS_pa_exceptionSummary_totalExceptionCount:
      'GRIDCOLUMNS_pa_exceptionSummary_totalExceptionCount',

    GRIDCOLUMNS_pa_topSqlSummary_topSqlList: 'GRIDCOLUMNS_pa_topSqlSummary_topSqlList',
    GRIDCOLUMNS_pa_topSqlSummary_topWasList: 'GRIDCOLUMNS_pa_topSqlSummary_topWasList',
    GRIDCOLUMNS_pa_topSqlSummary_sqlTrendSummaryList:
      'GRIDCOLUMNS_pa_topSqlSummary_sqlTrendSummaryList',
    GRIDCOLUMNS_pa_topSqlSummary_timedSqlSummaryList:
      'GRIDCOLUMNS_pa_topSqlSummary_timedSqlSummaryList',

    GRIDCOLUMNS_pa_topTxnSummary_topTxnList: 'GRIDCOLUMNS_pa_topTxnSummary_topSqlList',
    GRIDCOLUMNS_pa_topTxnSummary_topWasList: 'GRIDCOLUMNS_pa_topTxnSummary_topWasList',
    GRIDCOLUMNS_pa_topTxnSummary_txnTrendSummaryList:
      'GRIDCOLUMNS_pa_topTxnSummary_txnTrendSummaryList',
    GRIDCOLUMNS_pa_topTxnSummary_timedTxnSummaryList:
      'GRIDCOLUMNS_pa_topTxnSummary_timedTxnSummaryList',

    GRIDCOLUMNS_pa_threadDump_threadDumpDetail: 'GRIDCOLUMNS_pa_threadDump_threadDumpDetail',
    FILTERSEARCH_pa_threadDump_threadDumpDetail: 'FILTERSEARCH_pa_threadDump_threadDumpDetail',
    GRIDCOLUMNS_pa_threadDump_threadDumpAnalyzer_cpuHotspotAnalysisList:
      'GRIDCOLUMNS_pa_threadDump_threadDumpAnalyzer_cpuHotspotAnalysisList',
  },
  DATABASE: {
    ...ORACLE_ENVS,
    ...POSTGRESQL_ENVS,
    ...MYSQL_ENVS,
    ...SQLSERVER_ENVS,
    ...ALTIBASE_ENVS,
    ...TIBERO_ENVS,
    ...CLICKHOUSE_ENVS,
    ...REDSHIFT_ENVS,
    ...SINGLESTORE_ENVS,
  },
  TOOL: {
    GRIDCOLUMNS_pa_queryMangerHistory_queryRunHistory:
      'GRIDCOLUMNS_pa_queryMangerHistory_queryRunHistory',
    GRIDCOLUMNS_pa_queryManger_queryEditorResult: 'GRIDCOLUMNS_pa_queryManger_queryEditorResult',
  },
  KUBERNETES: {
    FILTERSEARCH_pa_kubernetesEventDetail_eventHistory:
      'FILTERSEARCH_pa_kubernetesEventDetail_eventHistory',
    FILTERSEARCH_pa_kubernetesEventDetail_workloadHistory:
      'FILTERSEARCH_pa_kubernetesEventDetail_workloadHistory',
    FILTERSEARCH_pa_kubernetesEventDetail_eventLog:
      'FILTERSEARCH_pa_kubernetesEventDetail_eventLog',
    GRIDCOLUMNS_pa_kubernetesEventDetail_eventLog: 'GRIDCOLUMNS_pa_kubernetesEventDetail_eventLog',
    FILTERSEARCH_pa_kubernetesHistoryManagementDetail_log:
      'FILTERSEARCH_pa_kubernetesHistoryManagementDetail_log',
    GRIDCOLUMNS_pa_kubernetesHistoryManagementDetail_log:
      'GRIDCOLUMNS_pa_kubernetesHistoryManagementDetail_log',
    METRIC_kubernetes_podEventView_eventDetail_metricChart:
      'METRIC_kubernetes_podEventView_eventDetail_metricChart_v2',
    METRIC_kubernetes_nodeEventView_eventDetail_metricChart:
      'METRIC_kubernetes_nodeEventView_eventDetail_metricChart',
    METRIC_kubernetes_pvcEventView_eventDetail_metricChart:
      'METRIC_kubernetes_pvcEventView_eventDetail_metricChart',
    METRIC_kubernetes_hpaEventView_eventDetail_metricChart:
      'METRIC_kubernetes_hpaEventView_eventDetail_metricChart',

    METRIC_kubernetes_podEventView_eventDetail_metricChart_timePeriod:
      'METRIC_kubernetes_podEventView_eventDetail_metricChart_timePeriod',
    METRIC_kubernetes_nodeEventView_eventDetail_metricChart_timePeriod:
      'METRIC_kubernetes_nodeEventView_eventDetail_metricChart_timePeriod',
    METRIC_kubernetes_pvcEventView_eventDetail_metricChart_timePeriod:
      'METRIC_kubernetes_pvcEventView_eventDetail_metricChart_timePeriod',
    METRIC_kubernetes_hpaEventView_eventDetail_metricChart_timePeriod:
      'METRIC_kubernetes_hpaEventView_eventDetail_metricChart_timePeriod',

    METRIC_kubernetes_podHistoryManagementView_historyManagementDetail_metricChart:
      'METRIC_kubernetes_podHistoryManagementView_historyManagementDetail_metricChart',
    METRIC_kubernetes_nodeHistoryManagementView_historyManagementDetail_metricChart:
      'METRIC_kubernetes_nodeHistoryManagementView_historyManagementDetail_metricChart',
    METRIC_kubernetes_pvcHistoryManagementView_historyManagementDetail_metricChart:
      'METRIC_kubernetes_pvcHistoryManagementView_historyManagementDetail_metricChart',
    METRIC_kubernetes_hpaHistoryManagementView_historyManagementDetail_metricChart:
      'METRIC_kubernetes_hpaHistoryManagementView_historyManagementDetail_metricChart',
  },
  KUBERNETES_PA: {
    GRIDCOLUMNS_pa_kubernetesEvent_eventList: 'GRIDCOLUMNS_pa_kubernetesEvent_eventList',
    GRIDCOLUMNS_pa_kubernetesResourceException_eventList:
      'GRIDCOLUMNS_pa_kubernetesResourceException_eventList',
    FILTERSEARCH_pa_kubernetesEvent: 'FILTERSEARCH_pa_kubernetesEvent',
    COLOR_pa_kubernetesEvent_heatmap: 'COLOR_pa_kubernetesEvent_heatmap',
    FILTERSEARCH_pa_kubernetesHistoryManagement: 'FILTERSEARCH_pa_kubernetesHistoryManagement',
    COLOR_pa_kubernetesHistoryManagement_heatmap: 'COLOR_pa_kubernetesHistoryManagement_heatmap',
    GRIDCOLUMNS_pa_kubernetesJobSummary_jobList: 'GRIDCOLUMNS_pa_kubernetesJobSummary_jobList',
    FILTERSEARCH_pa_kubernetesJobSummary_jobList: 'FILTERSEARCH_pa_kubernetesJobSummary_jobList',
  },
};
